import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const ContractorStatusValues = [
  "VETTING",
  "COLLECTING_DOCS",
  "REVIEWING_DOCS",
  "PAUSED",
  "GROWTH_TIER_REVIEW",
  "COMPLIANCE_REVIEW",
  "READY_TO_ONBOARD",
  "DOES_NOT_QUALIFY",
  "ACTIVE",
  "INACTIVE",
  "ALERT",
  "PROBATION",
  "FINAL_WARNING",
  "OFFBOARD",
  "RMC",
  "TIER_3",
] as const;
/**
 * Use this if you need to zod parse it
 */
export const ContractorStatusSchema = z.enum(ContractorStatusValues);
/**
 * Use this if you need to use the literal value
 */
export const ContractorStatus = ContractorStatusSchema.enum;
/**
 * Use this if you need to use the type
 */
export type ContractorStatus = z.infer<typeof ContractorStatusSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const ContractorStatusDisplayNames: Record<ContractorStatus, string> = {
  VETTING: "OPS Vetting",
  COLLECTING_DOCS: "Collecting docs",
  REVIEWING_DOCS: "Reviewing docs",
  GROWTH_TIER_REVIEW: "Growth tier review",
  COMPLIANCE_REVIEW: "Compliance review",
  READY_TO_ONBOARD: "Ready to onboard",
  DOES_NOT_QUALIFY: "Does not qualify",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PAUSED: "Paused",
  ALERT: "Alert",
  PROBATION: "Probation",
  FINAL_WARNING: "Final Warning",
  OFFBOARD: "Offboard",
  RMC: "RMC",
  TIER_3: "Tier 3",
} as const;

export const OnboardingStatuses = [
  ContractorStatus.VETTING, // Initial state when a contractor is first entered
  ContractorStatus.COLLECTING_DOCS, // Still collecting documents
  ContractorStatus.REVIEWING_DOCS, // Docs are in review with compliance team
] as const;

export const GrowthTierPauseEligibleStatuses: ContractorStatus[] = [
  ContractorStatus.ACTIVE,
  ContractorStatus.ALERT,
  ContractorStatus.PROBATION,
  ContractorStatus.FINAL_WARNING,
  ContractorStatus.COMPLIANCE_REVIEW,
];

export const CoverageActiveStatuses = [
  ContractorStatus.ACTIVE,
  ContractorStatus.ALERT,
  ContractorStatus.PROBATION,
  ContractorStatus.FINAL_WARNING,
] as const;

export const CoveragePendingStatuses = [ContractorStatus.COMPLIANCE_REVIEW, ContractorStatus.READY_TO_ONBOARD] as const;

export const CoverageRelevantStatuses = [...CoverageActiveStatuses, ...CoveragePendingStatuses] as const;
